import React from "react";
import FeatureDescriptionList from "./components/FeatureDescriptionList";
import circle from "../../assets/images/circle_background.png";
export default function FeatureHighlights() {
  return (
    <div className="relative bg-[#F7F7F8]">
      <section className="container mx-auto py-[40px] md:py-[42px] 2xl:py-[80px] ">
        <div className="mb-[16px] px-[16px] md:mb-[45px] md:px-0 2xl:mb-[80px]">
          <h1 className="mb-[18px] text-center font-manrope text-[20px] font-[800] leading-[28px] text-[#333333] md:text-center md:text-[26px] md:font-[800] md:leading-[36px] 2xl:text-center 2xl:text-[34px] 2xl:leading-[46px]">
            Features That Make Geo VPN the Best Choice
          </h1>

          <p className="text-center font-manrope text-[13px] font-[600] leading-[18px] text-[#666A7C] md:text-[15px] md:font-[600] md:leading-[22px] 2xl:text-[18px] 2xl:leading-[26px]">
            Packed with Powerful Features to Keep You Safe, Private, and
            <br className="hidden md:inline-block" />
            Connected—Wherever You Are.
          </p>
        </div>
        <FeatureDescriptionList />
      </section>
      <img
        src={circle}
        alt="background img"
        className="absolute right-[0%] top-[2.4%] hidden h-[169.07px] md:block 2xl:h-[317px]"
      />
    </div>
  );
}
